/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { LineItemTypeResponse } from '../models/line-item-type-response';

/**
 * Line item type APIs
 */
@Injectable({ providedIn: 'root' })
export class LineItemTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLineItemTypes()` */
  static readonly GetLineItemTypesPath = '/api/v1/line-item-types';

  /**
   * fetch escort line item types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLineItemTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLineItemTypes$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<LineItemTypeResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      LineItemTypeService.GetLineItemTypesPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<LineItemTypeResponse>;
        })
      );
  }

  /**
   * fetch escort line item types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLineItemTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLineItemTypes(
    params?: {},
    context?: HttpContext
  ): Observable<LineItemTypeResponse> {
    return this.getLineItemTypes$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<LineItemTypeResponse>): LineItemTypeResponse =>
          r.body
      )
    );
  }
}
